import React, { useContext } from "react";
import { Box, Paper } from "@mui/material";
import { transformBlockData } from "gatsby-frontend";
import { SiteContext } from "gatsby-frontend/src/Site";
import { SingleContext } from "gatsby-frontend/src/Page";
import { Block, Row, Tab } from "./../../";

function Blocks({
	data,
	fullWidth = false,
	isSidebar = false,
	className = "",
}) {
	const { sitemap_arr, themeConfig, formsConfig, bundles, configs } =
		useContext(SiteContext);
	const { attributes, relationships } = useContext(SingleContext);
	const sidebarStyle = themeConfig?.customOptions?.sidebarStyle || "default";

	if (isSidebar && sidebarStyle === "box") {
		return (
			<Paper
				className="sidebar-block"
				sx={(theme) => ({
					padding: theme.spacing(2),
					"& > *:not(:first-child)": { marginTop: theme.spacing(2) },
					" & .heading-h2": {
						fontSize: theme.typography.subtitle1.fontSize,
					},
				})}
			>
				{
					<>
						{data
							.filter(
								(entity) => typeof entity !== "undefined" && entity.type !== "unknown" && entity.id !== "missing"
							)
							.map((entity) => {
								let item_data = transformBlockData({
									entity,
									sitemap: sitemap_arr,
									singleAttributes: attributes,
									singleRelationships: relationships,
									formsConfig,
									bundles,
									configs,
								});
								return (
									<Block
										key={item_data.id}
										{...item_data}
										fullWidth={fullWidth}
										isSidebar={isSidebar}
									/>
								);
							})}
					</>
				}
			</Paper>
		);
	} else {
		return (
			<Box
				className={className}
				sx={(theme) => ({
					"& > *": !fullWidth
						? {
								marginTop: `20px !important`,
								marginBottom: `0px !important`,
								"&:first-child, &.MuiGrid-root": {
									marginTop: `0px !important`,
								},
						  }
						: {},
				})}
			>
				<>
					{data
						.filter(
							(entity) => entity.type !== "unknown" && entity.id !== "missing"
						)
						.map((entity) => {
							switch (entity.type) {
								case "node--row":
									return (
										<Row
											key={entity.id}
											{...entity}
											fullWidth={fullWidth}
											centered={!!entity.attributes.field_centered}
										/>
									);
								case "node--accordion_tab":
									return <Tab key={entity.id} {...entity} />;
								default:
									let item_data = transformBlockData({
										entity,
										sitemap: sitemap_arr,
										singleAttributes: attributes,
										singleRelationships: relationships,
										formsConfig,
										bundles,
										configs,
									});
									return (
										<Block
											key={item_data.id}
											{...item_data}
											fullWidth={fullWidth}
											isSidebar={isSidebar}
										/>
									);
							}
						})}
				</>
			</Box>
		);
	}
}

export default Blocks;
